import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getReceiveCalendarApi,
    getReceiveDictTreeApi,
    getReceiveByDateApi,
    getReceiveByIdApi,
    getReceiveActivitiesDataApi,
    postReceiveCommentApi,
    putReceiveCommentApi,
    postReceiveActivitiesDataApi,
    getPreplotRListApi,
    getPreplotLinesApi,
    getGeometryOBNApi
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    listData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    save: false,
    id: '',
    lineListData: null, // 线列表
}

/* 获取日历上的数据 */
export const getReceiveCalendarAction = createAsyncThunk(
    'ReceiveSlice/getReceiveCalendarAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getReceiveCalendarApi(params)
            return data.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据字典 */
export const getReceiveDictDataAction = createAsyncThunk(
    'ReceiveSlice/getReceiveDictDataAction',
    async (dictType, thunkAPI) => {
        const receiverActivityDataDict = getReceiveDictTreeApi(dictType[0])
        const receiverStatusDataDict = getReceiveDictTreeApi(dictType[1])
        const receiverTypeDataDict = getReceiveDictTreeApi(dictType[2])
        const receiverLineTypeDataDict = getReceiveDictTreeApi(dictType[4])
        const preplotList = getPreplotRListApi(dictType[3])
        const geometryOBN = getGeometryOBNApi(dictType[3])
        return Promise.all([receiverActivityDataDict, receiverStatusDataDict, receiverTypeDataDict, preplotList, geometryOBN, receiverLineTypeDataDict])
            .then(dictData => dictData)
            .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
    }
)

// 激发文件线
export const getReceiveLinesDataAction = createAsyncThunk(
    'AcquisitionSlice/getReceiveLinesDataAction',
    async (id, thunkAPI) => {
        try {
            const lineListData = await getPreplotLinesApi(id) // 通过文件 id 查询
            return lineListData?.data?.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 通过日期获取 id */
export const getReceiveByDateAction = createAsyncThunk(
    'ReceiveSlice/getReceiveByDateAction',
    async (listDataParams, thunkAPI) => {
        try {
            const commentData = await getReceiveByDateApi(listDataParams) // 通过日期查询 id
            return commentData?.data?.data?.id
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据 */
export const getReceiveDataAction = createAsyncThunk('ReceiveSlice/getReceiveDataAction', async (id, thunkAPI) => {
    const commentData = getReceiveByIdApi(id) // 通过 id 查询
    const activitiesData = getReceiveActivitiesDataApi(id)
    return Promise.all([commentData, activitiesData])
        .then(listData => listData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 保存数据 */
export const postReceiveDataAction = createAsyncThunk(
    'ReceiveSlice/postReceiveDataAction',
    async ({ id, commentParams, activitiesParams }, { dispatch }) => {
        let vid
        try {
            if (!id) {
                const commentData = await postReceiveCommentApi(commentParams) // 新增
                vid = commentData.data.data.id
                await postReceiveActivitiesDataApi(activitiesParams, vid)
                dispatch(ReceiveSlice.actions.addId(vid))
                return { isTrue: true, id: vid } // 已保存状态
            } else {
                vid = id
                await putReceiveCommentApi(commentParams, id) // 修改
                await postReceiveActivitiesDataApi(activitiesParams, id)
                return { isTrue: true, id } // 已保存状态
            }
        } catch (error) {
            dispatch(ReceiveSlice.actions.addId(vid))
            dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const ReceiveSlice = createSlice({
    name: 'ReceiveSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.listData = null
            state.calendarData = null
            state.save = false
            state.id = ''
        },
        /* 当前日历主 id */
        addId: (state, action) => {
            state.id = action.payload
        },
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
        /* 清除接收文件数据 */
        clearFielData: (state, action) => {
            state.pointsListData = null
            state.lineListData = null
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getReceiveCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getReceiveDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        /* 线 */
        [getReceiveLinesDataAction.fulfilled.type]: (state, action) => {
            state.lineListData = action.payload
        },

        /* 提交总结数据 */
        [postReceiveDataAction.fulfilled.type]: (state, action) => {
            state.save = action.payload
        },

        /* 获取回显数据 */
        [getReceiveDataAction.fulfilled.type]: (state, action) => {
            state.listData = action.payload
        },

        /* 通过日期，获取 id */
        [getReceiveByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
